<common-ui-components-page-layout [showBackIcon]="false">
  <div
    id="cover-image-container"
    class="position-relative"
  >
    <div id="cover-image">
      @if (store()) {
        <ui-api-image
          [imageId]="store()!.coverImageId"
          [width]="'100%'"
          [height]="'100%'"
          class="w-100 h-100 api-image"
          [styles]="{ objectFit: 'cover', filter: isDisabled() ? 'grayscale(1)' : 'unset' }"
          [fallbackImage]="'assets/fallback/store-info-fallback.png'"
        ></ui-api-image>
      }
    </div>
    <div class="position-absolute d-flex cursor-pointer justify-content-space-between">
      <common-icon-dp-icon
        [icon]="'arrow-right'"
        [iconSize]="'24'"
        [iconType]="'linear'"
        [classes]="'text-onback-high'"
        (click)="goBack()"
      ></common-icon-dp-icon>
      @if (store()?.score) {
        <common-rate-count
          [rateAmount]="store()?.score?.score!"
          [rateCount]="store()?.score?.count!"
        ></common-rate-count>
      }
    </div>
  </div>
  <stores-applet-store-overview
    [store]="store()"
    [isBlurred]="true"
    [showBranchesButton]="!isSingleBranch()"
  ></stores-applet-store-overview>
  @if (branches()?.length) {
    <div class="ty-75 px-plus mb-big">
      <stores-applet-branch-overview
        [branch]="branches()![0]"
        [showBadge]="!isSingleBranch()"
      ></stores-applet-branch-overview>
    </div>
  }
  <div class="d-flex ty-75 flex-column gap-medium">
    <ngx-accordion
      class="p-minus border-100 radius-minus border-color-light mx-plus"
      [configs]="storeIntroAccordionConfig()"
    ></ngx-accordion>
    @if (showStoreDetailsAccordion() && storeDetailsAccordionConfig().length) {
      <div class="d-flex flex-column gap-small p-minus border-100 radius-minus border-color-light mx-plus">
        <div class="d-flex st-8 justify-content-start">پرداخت حضوری از طریق:</div>
        <ngx-accordion
          class="py-tiny"
          [configs]="storeDetailsAccordionConfig()"
        ></ngx-accordion>
      </div>
    }
  </div>

  @if (vouchers() && vouchers()?.length) {
    <div class="mx-plus ty-75">
      @for (voucher of vouchers(); track voucher.code) {
        <div class="mt-big">
          <common-ui-components-discount-tag
            [title]="voucher.description!"
            [code]="voucher.code!"
          ></common-ui-components-discount-tag>
        </div>
      }
    </div>
  }
  @if (store()) {
    <stores-applet-store-products [store]="store()"></stores-applet-store-products>
  }
</common-ui-components-page-layout>
